import { useEffect, useState } from "react";

interface BrandPillTutorialProps {
  onSkip: () => void;
  targetSelector?: string;
}

const BrandPillTutorial: React.FC<BrandPillTutorialProps> = ({
  onSkip,
  targetSelector = "[data-brand-pill='true']",
}) => {
  const [targetRect, setTargetRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    const updateTarget = () => {
      const target = document.querySelector(targetSelector);
      setTargetRect(target?.getBoundingClientRect() || null);
    };

    const frame = window.requestAnimationFrame(updateTarget);
    window.addEventListener("resize", updateTarget);
    window.addEventListener("scroll", updateTarget, true);

    const timeout = window.setTimeout(onSkip, 5000);

    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", updateTarget);
      window.removeEventListener("scroll", updateTarget, true);
      window.clearTimeout(timeout);
    };
  }, [onSkip, targetSelector]);

  if (!targetRect) return null;

  const top = Math.min(targetRect.bottom + 18, window.innerHeight - 190);
  const left = Math.max(
    16,
    Math.min(Math.max(targetRect.left, 16), window.innerWidth - 340),
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-[130] bg-[#050b10]/80 font-poppins text-[#f5f5f5] backdrop-blur-sm">
      {targetRect && (
        <div
          className="pointer-events-none absolute rounded-full border-2 border-[#c3f620] shadow-[0_0_0_9999px_rgba(5,11,16,0.55),0_0_28px_rgba(195,246,32,0.75)]"
          style={{
            height: targetRect.height + 14,
            left: targetRect.left - 7,
            top: targetRect.top - 7,
            width: targetRect.width + 14,
          }}
        />
      )}

      <div
        className="pointer-events-auto absolute max-w-[320px] rounded-lg border border-[#00a878]/50 bg-[#0d1821] p-5 shadow-2xl"
        style={{ left, top }}
      >
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#00a878]">
          Quick Tip
        </p>
        <p className="mt-3 text-sm leading-6 text-[#f5f5f5]/85">
          Click a brand name to view only that brand&apos;s creatives or videos.
        </p>
        <button
          type="button"
          onClick={onSkip}
          className="mt-4 rounded-lg border border-[#f5f5f5]/20 px-4 py-2 text-sm font-semibold text-[#f5f5f5] transition hover:border-[#00a878] hover:text-[#c3f620]"
        >
          Skip
        </button>
      </div>
    </div>
  );
};

export default BrandPillTutorial;
